// extracted by mini-css-extract-plugin
module.exports = {"basketPage":"BasketPage-module__basketPage___GQBJJ"};